import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';

const deleteBlock = (collectionPath, entityId, { blockToRemoveId }) =>
  axios
    .delete(
      getUrl.apiV2(`${collectionPath}/${entityId}/items/${blockToRemoveId}`),
    )
    .catch(generateApiError());

export default deleteBlock;
